{
	"success": {
		"title": "Pago confirmado",
		"message": "Tu pago se procesó con éxito. Ya puedes cerrar esta página."
	},
	"pending": {
		"title": "Pago en proceso",
		"message": "Estamos confirmando tu pago. Esto puede tardar unos instantes."
	},
	"failed": {
		"title": "Pago no completado",
		"message": "No pudimos procesar tu pago. Inténtalo de nuevo o usa otro método."
	},
	"canceled": {
		"title": "Pago cancelado",
		"message": "El pago fue cancelado."
	},
	"unknown": {
		"title": "Estado no disponible",
		"message": "No pudimos identificar el estado de tu pago."
	}
}
